import React from 'react';
import { Link } from 'react-router-dom';
import SafeIcon from '../../common/SafeIcon';

const CallToAction = () => {
  return (
    <section className="relative py-24 bg-blue-600 overflow-hidden">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mr-20 -mt-20 w-96 h-96 rounded-full bg-blue-500 opacity-50 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 -ml-20 -mb-20 w-80 h-80 rounded-full bg-blue-700 opacity-50 blur-3xl"></div>
      
      <div className="relative max-w-5xl mx-auto px-4 text-center z-10">
        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6">
          準備好展開海上探險了嗎？
        </h2>
        <p className="text-xl text-blue-100 mb-10 max-w-2xl mx-auto">
          暑假期間熱門時段容易客滿，建議提早 21-30 天預約登島證與船位，確保您的完美假期！
        </p>
        
        <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
          <Link 
            to="/contact" 
            className="flex items-center justify-center px-8 py-4 bg-white text-blue-600 rounded-full font-bold text-lg hover:bg-slate-100 transition-colors shadow-lg w-full sm:w-auto"
          >
            <SafeIcon name="Calendar" className="mr-2" />
            線上申請登島
          </Link>
          <a 
            href="https://line.me/ti/p/J2MCDvI-Tu" 
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center px-8 py-4 bg-[#00B900] text-white rounded-full font-bold text-lg hover:bg-[#009900] transition-colors shadow-lg w-full sm:w-auto"
          >
            <SafeIcon name="MessageCircle" className="mr-2" />
            LINE 專人客服
          </a>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;